import { atom } from "jotai";

import { BookingWizard } from "../../../types";
import { BookingWizardDataAtom } from "../../stores";

export const removePlayerAtom = atom(null, (get, set, playerId: string) => {
  const bookingWizardData = get(BookingWizardDataAtom);
  if (!bookingWizardData) {
    //@TODO: this is an error
    return;
  }

  if (bookingWizardData.type === "GolfBooking") {
    const filteredRounds = bookingWizardData.rounds
      ?.filter((r) => r.player.id !== playerId)
      .map((r, i) => ({
        ...r,
        index: i,
      }));

    set(BookingWizardDataAtom, {
      ...bookingWizardData,
      rounds: filteredRounds,
    });
  } else if (bookingWizardData.type === "DurationBooking") {
    const filteredRounds = bookingWizardData.rounds
      ?.filter((r) => r.player.id !== playerId)
      .map((r, i) => ({
        ...r,
        index: i,
      }));

    set(BookingWizardDataAtom, {
      ...bookingWizardData,
      rounds: filteredRounds,
    });
  } else if (bookingWizardData.type === "LessonBooking") {
    const filteredRounds = bookingWizardData.rounds
      ?.filter((r) => r.player.id !== playerId)
      .map((r, i) => ({
        ...r,
        index: i,
      }));

    set(BookingWizardDataAtom, {
      ...bookingWizardData,
      rounds: filteredRounds,
    });
  } else if (bookingWizardData.type === "RequestBooking") {
    const filteredRounds = bookingWizardData.rounds
      ?.filter((r) => r.player?.id !== playerId)
      .map((round) => round)
      .reduce<BookingWizard.RequestRound[]>((rounds, round) => {
        const bookingIndex = round.bookingIndex ?? 0;
        const index = rounds.filter(
          (existingRound) => (existingRound.bookingIndex ?? 0) === bookingIndex
        ).length;

        rounds.push({ ...round, index });
        return rounds;
      }, []);

    set(BookingWizardDataAtom, {
      ...bookingWizardData,
      rounds: filteredRounds,
    });
  }
});
